import Link from 'next/link'
import { ext } from '@/utils/linkTarget'
import Inner from './inner'

const ButtonLink = ({
  name,
  link,
  size = 'small',
  color = 'primary',
  className,
  target,
  ...args
}) => {
  const base = `relative w-full md:w-fit overflow-hidden border font-ttDrugsTrial uppercase group transition-all duration-500`
  const sizes = {
    small:
      'px-[16px] py-[12px] md:px-[30px] md:py-[20px] text-rectangleButtonMobile md:text-rectangleButtonDesktop',
    big:
      'px-[18px] py-[15px] md:px-[35px] md:py-[25px] text-rectangleBigButtonMobile md:text-rectangleBigButtonDesktop',
  }
  const textColor = {
    primary: 'border-olive text-olive',
    secondary: 'border-dune text-dune',
  }

  return (
    <Link
      scroll={false}
      href={link}
      {...args}
      {...(target === '_blank' ? ext(link) : target ? { target } : {})}
      className={`${base} ${sizes[size]} ${textColor[color]} ${className}`}
    >
      <Inner name={name} color={color} />
    </Link>
  )
}

export default ButtonLink
